module.exports = __webpack_public_path__ + "static/media/bg_GirlModel1.b426b1ca.jpg";